import React from "react";
import { Fragment } from "react";

export default function AddChecklistHeader() {
  return (
    <Fragment>
      <div className="col-sm-5 ">
        <h2>Export</h2>
      </div>
    </Fragment>
  );
}
